import { Action } from "redux";
import { isActionType } from "./utils.js";

const ActionTypeKeys = ["PRESS_ESCAPE_KEY"] as const;

type ActionType = (typeof ActionTypeKeys)[number];
type ActionBase<T extends ActionType> = Action<T>;

type PressEscapeKey = ActionBase<"PRESS_ESCAPE_KEY">;

export type KeyboardAction = PressEscapeKey;

export const isKeyboardAction = (action: Action): action is KeyboardAction =>
  isActionType(action, ActionTypeKeys);

export const pressEscapeKey = (): PressEscapeKey => ({
  type: "PRESS_ESCAPE_KEY",
});
